module.exports = __webpack_public_path__ + "static/media/materialDelivery.24591458.svg";